import { c as _c } from "react/compiler-runtime";
import SvgIcon from '@mui/material/SvgIcon';

// ----------------------------------------------------------------------

export function AvatarShape(t0) {
  const $ = _c(12);
  let other;
  let sx;
  if ($[0] !== t0) {
    ({
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
  } else {
    other = $[1];
    sx = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      width: 144,
      height: 62,
      color: "background.paper"
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== sx) {
    t2 = Array.isArray(sx) ? sx : [sx];
    $[4] = sx;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = [t1, ...t2];
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M111.3 23.9C100.7 13.4 92.8 0 72.6 0h-1.2C51.2 0 43.3 13.4 32.7 23.9 24.9 33.5 13.2 35.6 0 36v26h144V36c-13.2-.4-25-2.5-32.7-12.1" fill="currentColor" fillRule="evenodd" />;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== other || $[10] !== t3) {
    t5 = <SvgIcon fill="none" viewBox="0 0 144 62" xmlns="http://w3.org/2000/svg" sx={t3} {...other}>{t4}</SvgIcon>;
    $[9] = other;
    $[10] = t3;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}